import React from "react";
import {permissionObj} from "../../../../../Helpers/permission";
import CustomTable from "../../../../../components/table/CustomTable";
import InvitationMainHeader from "./InvitationMainHeader";
import {OngoingTableApp} from "../Functionality/OngoingTableApp";
import InvitationStatusCardContent from "./InvitationStatusCardContent";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import routes from "../../../../../Routes/routes";
import ConfirmModal from "../Modal/ConfirmModal";
import InvitationDetailsModal from "../Modal/InvitationDetailsModal";
import {INVITATION_VIEW_TYPE} from "../Model/Model";
import CopyInvitationLinkModal from "../Modal/CopyInvitationLinkModal";
import {TABS_VISITOR} from "../../Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const OngoingTable = (props) => {
    const {
        selectedList,
        setSelectedList,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        setBodyForExport,
        finalArray,
        setFinalArray,
        criteria,
        setCriteria,
        search,
        setSearch,
        modified,
        setModified
    } = props;

    const {
        t,
        DEV,
        userId,
        permission,
        navigate,
        setResults,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        tableId,
        searchId,
        isAllChecked,
        thead,
        tbody,
        cancelModal,
        setCancelModal,
        detailsModal,
        setDetailsModal,
        invitationLinkModal,
        setInvitationLinkModal,
        itemSelected,
        setItemSelected,
        cancelFn,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
    } = OngoingTableApp({
        selectedList,
        setSelectedList,
        criteria,
        setCriteria,
        searchElement,
        finalArray,
        setSearch,
        setBodyForExport,
        modified,
        setModified
    });

    return (
        <>
            <InvitationMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                finalArray={finalArray}
                setFinalArray={setFinalArray}
                DEV={DEV}
                permission={permission}
                userId={userId}
                viewType={INVITATION_VIEW_TYPE.ONGOING}
            />
            <InvitationStatusCardContent/>

            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("you_haven_not_created_any_invitation")}</p>
                                </div>
                        { (DEV || permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_CREATE)) &&
                        <CustomButtonLink splitName={false} id={'btn_ot_create'} card={true}
                                        onClick={() => navigate(routes.visitorInvitation.create)}
                                          name={'create_new_invitation'}/>
                        } </>
                        : undefined
                    }
                    withoutHeight={true}
                />
                {pagination()}
            </div>

            {itemSelected && <InvitationDetailsModal
                    viewType={INVITATION_VIEW_TYPE.ONGOING}
                backUrl={{ pathname: routes.visitor.list, state: { currentTab: TABS_VISITOR.INVITATIONS.INDEX, invitationId:itemSelected?.id }}}
                    show={detailsModal}
                    onHide={() => {
                        setDetailsModal(false);
                        setItemSelected(null);
                    }}
                    itemSelected={itemSelected}
                    showIdentityValidationButton={true}
                />
            }

            <ConfirmModal
                show={cancelModal}
                onHide={() => setCancelModal(false)}
                onClickFn={() => {
                    cancelFn({
                        ids: itemSelected,
                    });
                    setCancelModal(false);
                }}
                title_modal={'cancel_invitation'}
                isReset={() => setItemSelected([])}
                description={t('are_you_sure_you_want_to_cancel_the_invitation')}
            />

            {invitationLinkModal && itemSelected &&
                <CopyInvitationLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={itemSelected}
                />
            }
        </>
    );
};

export default OngoingTable;
